import {
  Disconnectable,
  ElementEventCallback,
  ElementsEventObserverPort,
  ElementsScrollObserverPort,
} from '../../../ports'

export class ElementsScrollObserver implements ElementsScrollObserverPort {
  constructor(
    private readonly elementsEventObserver: ElementsEventObserverPort
  ) {}

  observeOnce(
    elementsSelector: string,
    onScrolledCallback: ElementEventCallback<'scroll'>
  ): Disconnectable {
    return this.elementsEventObserver.observeOnce(
      elementsSelector,
      'scroll',
      onScrolledCallback
    )
  }
}
